import { useParams } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { BackArrowIcon, BaseError } from './BaseError'

export function NotFoundComponent() {
	const { t } = useTranslation('common')
	const { companyId: orgSlug } = useParams({ strict: false })

	return (
		<BaseError
			errorCode={404}
			heading={t('errors.notFound.heading')}
			message={t('errors.notFound.message')}
			suggestions={[
				t('errors.notFound.suggestion1'),
				t('errors.notFound.suggestion2'),
				t('errors.notFound.suggestion3'),
			]}
			actions={[
				{
					label: orgSlug ? t('errors.notFound.backToDashboard') : t('errors.notFound.goToLogin'),
					ariaLabel: orgSlug ? t('errors.notFound.returnToDashboard') : t('errors.notFound.goToLoginPage'),
					to: orgSlug ? `/company/${orgSlug}` : '/auth',
					icon: <BackArrowIcon />,
				},
			]}
		/>
	)
}
